/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ApiSortNotificationsBy,
  NotificationResponsePaginatedResponse,
  PaginatedNotificationResponse,
  UpdateNotificationRequest,
  V1NotificationsListError,
  V1NotificationsUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Notification<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Notification
   * @name V1NotificationsList
   * @request GET:/api/v1/notifications
   * @secure
   * @response `200` `PaginatedNotificationResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1NotificationsList = (
    query?: {
      /**
       * Starting from 1
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageNumber?: number;
      /**
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageSize?: number;
      sortBy?: ApiSortNotificationsBy;
      sortAscending?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PaginatedNotificationResponse, V1NotificationsListError>({
      path: `/api/v1/notifications`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name V1NotificationsUpdate
   * @request PUT:/api/v1/notifications/{notificationId}
   * @secure
   * @response `200` `NotificationResponsePaginatedResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1NotificationsUpdate = (
    notificationId: string,
    data: UpdateNotificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<NotificationResponsePaginatedResponse, V1NotificationsUpdateError>({
      path: `/api/v1/notifications/${notificationId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
